import { useFetch } from "~vue/api";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

type RefinePayload = {
    current_content: string;
    refinement_instruction: string;
};

type RefineSectionResponse = {
    refined_content: string;
};

export const useProfileRefine = () => {
    const { t } = useI18n();
    const refinementPayload = ref<RefinePayload | null>(null);
    const {
        data: refinementData,
        error: refinementError,
        execute: executeRefinement,
        isFetching: isRefining,
    } = useFetch("/api/accounts/profile/refine-section/", { immediate: false }).post(refinementPayload).json<RefineSectionResponse>();

    const handleRefine = async ({ currentContent, instruction }: { currentContent: string; instruction: string }) => {
        refinementPayload.value = { current_content: currentContent, refinement_instruction: instruction };
        refinementError.value = null;

        try {
            await executeRefinement();
        } catch {
            refinementError.value = t("profile.collaboration.refine.failed");
        }
    };

    return {
        // refine
        handleRefine,
        refinementError,
        refinementData,
        isRefining,
    };
};
